import "./FilterCollege.css";
// import { IoSearch } from "react-icons/io5";
// import { SiMicrosoftexcel } from "react-icons/si";

const FilterCollege = () => {
  return (
    <>
      <div className="college-all-course-inner-main-wrapper">
        <div className="headertable">
          <h5>College</h5>
          <table>
            <thead>
              <tr>
                <th>Course</th>
                <th>Semester</th>
                <th>Subject</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>BCA</td>
                <td>semester 1</td>
                <td>Computer</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FilterCollege;
